import { render, staticRenderFns } from "./offlineTraining.vue?vue&type=template&id=2d4f9f18&scoped=true&"
import script from "./offlineTraining.vue?vue&type=script&lang=js&"
export * from "./offlineTraining.vue?vue&type=script&lang=js&"
import style0 from "./offlineTraining.vue?vue&type=style&index=0&id=2d4f9f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f9f18",
  null
  
)

export default component.exports